'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'comet';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'e003';
var svgPathData = ['M491.12794.70921c-38.6972,11.5936-111.77976,34.29644-187.67439,61.2961-2.09343-6.99991-3.99939-13.49983-5.5929-18.59351a16.058,16.058,0,0,0-22.90274-9.49988c-42.39976,22.09347-152.77349,82.59271-214.37343,142.4982-1.09359,1-2.49962,2-3.49947,3A194.83045,194.83045,0,1,0,332.6522,454.90662c.99985-1,1.9997-2.40622,2.99954-3.49995,59.78772-61.6086,120.3722-172.10721,142.47819-214.40356a16.06158,16.06158,0,0,0-9.49854-22.906c-5.20233-1.59373-11.6076-3.5-18.60653-5.59368,26.99587-75.999,49.69552-148.99813,61.30311-187.70077A16.18325,16.18325,0,0,0,491.12794.70921ZM315.33454,300.35583l-50.586,49.33337,11.92787,69.72764a15.3022,15.3022,0,0,1-22.19583,16.13651L191.9589,402.626l-62.52168,32.92732c-11.07253,5.93743-24.32831-3.5312-22.19582-16.13651l11.99816-69.72764L68.64574,300.35583a15.31416,15.31416,0,0,1,8.46746-26.13639l69.85258-10.19714,31.26475-63.46795a15.29578,15.29578,0,0,1,27.45673,0L236.952,264.0223l69.85259,10.19714A15.34634,15.34634,0,0,1,315.33454,300.35583Z', 'M77.1132,274.21944l69.85258-10.19714,31.26475-63.46795a15.29578,15.29578,0,0,1,27.45673,0L236.952,264.0223l69.85259,10.19714a15.34634,15.34634,0,0,1,8.52994,26.13639l-50.586,49.33337,11.92787,69.72764a15.3022,15.3022,0,0,1-22.19583,16.13651L191.9589,402.626l-62.52168,32.92732c-11.07253,5.93743-24.32831-3.5312-22.19582-16.13651l11.99816-69.72764L68.64574,300.35583A15.31416,15.31416,0,0,1,77.1132,274.21944Z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faComet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;